<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.userId"
        placeholder="请输入ID"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.withdrawNo"
        placeholder="请输入订单号"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.channelTradeNo"
        placeholder="请输入渠道交易号"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.status"
        placeholder="提现状态"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in optionStatus"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <el-select
        v-model="listQuery.accountType"
        placeholder="提现方式"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in optionType"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        style="margin-left: 10px"
        >搜索</el-button
      >
      <!-- <el-button
        class="filter-item"
        icon="el-icon-download"
        @click="handleExport"
        style="margin-left: 10px"
        >导出</el-button
      > -->
    </div>

    <!-- <div style="margin-bottom: 5px">提现数量:{{ total }}</div> -->

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column
        align="center"
        prop="userId"
        label="用户ID"
        width="95"
      ></el-table-column>
      <el-table-column
        label="提现单号"
        align="center"
        prop="withdrawNo"
        width="100"
      ></el-table-column>
      <el-table-column
        label="渠道交易号"
        align="center"
        prop="channelTradeNo"
        width="100"
      ></el-table-column>
      <el-table-column
        label="支付渠道"
        align="center"
        prop="channel"
        width="140"
      ></el-table-column>
      <el-table-column
        label="真实姓名"
        align="center"
        prop="realName"
        width="100"
      ></el-table-column>
      <el-table-column
        label="账户信息"
        align="center"
        prop="accountInfo"
        width="120"
      ></el-table-column>
      <el-table-column
        label="提现金额"
        align="center"
        prop="amount"
        width="160"
      ></el-table-column>
     <el-table-column
        label="提现手续费"
        align="center"
        prop="fee"
        width="160"
      ></el-table-column>
      <el-table-column
        label="到账金额"
        align="center"
        prop="actualAmount"
        width="160"
      ></el-table-column>
      <el-table-column label="提现状态" align="center" prop="category">
        <template slot-scope="scope">
          {{ optionStatus[Number(scope.row.status)].value }}
        </template>
      </el-table-column>
      <el-table-column label="账户类型" align="center" prop="type">
        <template slot-scope="scope">
          {{ optionType[Number(scope.row.accountType) - 1].value }}
        </template>
      </el-table-column>
      
      <el-table-column
        align="center"
        prop="ctdate"
        label="创建时间"
        width="180"
      >
        <template slot-scope="scope">
          <span>{{ formatApiDate(scope.row.ctdate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="100"
        fixed="right"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            type="warning"
            size="mini"
            @click="onTui(scope.row)"
            class="comm_but_warp"
            v-if="scope.row.status === 1 && scope.row.accountType === 1"
            >退款</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    
  </div>
</template>

<script>
import { getWithdrawalList, exportList, feedback,getWithdrawRecordList,wechatCancelTransfer } from "@/api/finance";
import { formatApiDate } from "@/utils/utils";
import { uploadXlsx } from "@/utils/index";
import {
  DIALOG_TITLE_TYPE,
  getValue,
  FINANCE_WITHDRAWAL_STATUS,
  ACCOUNT_CATEGORY,
  ACCOUNT_TYPE,
  UPLOAD_IMG_TYPE
} from "@/utils/enumUtile";
import UploadList from "@/views/components/uploadList";
import DataPicker from "@/views/components/dataPicker";

export default {
  computed: {
    formatApiDate() {
      return formatApiDate;
    },
    DIALOG_TITLE_TYPE() {
      return DIALOG_TITLE_TYPE;
    },
    FINANCE_WITHDRAWAL_STATUS() {
      return FINANCE_WITHDRAWAL_STATUS;
    },
    ACCOUNT_CATEGORY() {
      return ACCOUNT_CATEGORY;
    },
    ACCOUNT_TYPE() {
      return ACCOUNT_TYPE;
    },
    UPLOAD_IMG_TYPE() {
      return UPLOAD_IMG_TYPE;
    }
  },
  components: { UploadList, DataPicker },
  filters: {},
  data() {
    return {
      list: null,
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        pageSize: 20,
        status:null,
        userId: null,
        withdrawNo: null,
        channelTradeNo: null,
        accountType: null, //申请开始时间
      },
      optionStatus:[
        {key:0,value:'待处理'},
        {key:1,value:'处理中'},
        {key:2,value:'成功'},
        {key:3,value:'失败'},
        {key:4,value:'已退款'},
      ],
      optionType:[
        {key:1,value:'微信'},
        {key:2,value:'支付宝'},
        {key:3,value:'银行卡'},
      ],
      examineVisible: false, // 审核的弹框
      examineObj: {}, // 审核的弹框
      examineRules: {
        status: [
          { required: true, message: "提现结果不能为空", trigger: "change" }
        ]
      },
      examineForm: {
        id: 0, //
        status: null,
        // proof: [], // 打款凭证
        remark: null // 备注
      }
    };
  },
  created() {
    this.getList();
  },
  watch: {},
  methods: {
    getValue,
    onTui(row){
      this.$confirm("是否同意退款, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          let params = {
            outBillNo:row.transferBillNo
          }
          wechatCancelTransfer(params).then(res=>{
            if(res.bizcode == 100){
              this.$message({
                type: "success",
                message: "退款成功",
              });
              this.getList();
            }
            
          }).finally(() => {
              this.listLoading = false;
            });
         
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
      
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    /**
     * 查询列表
     */
    getList() {
      this.listLoading = true;
      const form = this.listQuery;
      const params = {
        ...form
      };
      getWithdrawRecordList(params)
        .then(response => {
          this.list = response.data.entitys;
          this.total = response.data.totalCount;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },

    // 审核 start
    checkExamineVisible(val, obj = {}) {
      this.examineObj = obj;
      if (obj && Object.keys(obj).length !== 0) {
        this.examineForm.id = obj.id;
      }
      if (!val) {
        this.examineForm.id = 0;
        this.examineForm.status = null;
        // this.examineForm.proof = null;
        this.examineForm.remark = null;
        this.$refs.examineForm.resetFields();
      }
      this.examineVisible = val;
    },
    examineOk() {
      this.$refs["examineForm"].validate(valid => {
        if (valid) {
          const form = this.examineForm;
          const params = {
            ...form
          };
          // if (form.proof && form.proof.length !== 0) {
          //   const urlArr = form.proof.map(obj => obj["dbUrl"]);
          //   params.proof = urlArr.join(",");
          // }
          feedback(params).then((resp) => {
            if(resp && resp.bizcode === 100){
              this.getList();
              this.checkExamineVisible(false, {});
              this.$notify({
                title: "成功",
                message: "审核成功",
                type: "success",
                duration: 2000
              });
            }

          });
        }
      });
    },
    // 审核 end
    /**
     *  获取图片的值
     * @param type
     * @param value
     */
    getImgsValueFunc(type, value) {
      if (type === "proof") {
        this.examineForm.proof = value;
      }
    },
    /**
     * 获取时间
     * @param type
     * @param value
     */
    getPickerValueFunc(type, value) {
      if (type === "apply") {
        this.listQuery.applyStartTime = value[0];
        this.listQuery.applyEndTime = value[1];
      }
      if (type === "pay") {
        this.listQuery.payStartTime = value[0];
        this.listQuery.payEndTime = value[1];
      }
    },
    /**
     * 导出
     */
    handleExport() {
      const form = this.listQuery;
      const params = {
        ...form
      };
      exportList(params).then(response => {
        uploadXlsx(response, "用户提现申请表");
      });
    }
  }
};
</script>
<style scoped lang="scss">
.el-dropdown-link {
  cursor: pointer;
  margin-left: 10px;
}
.comm_but_warp {
  margin-bottom: 10px;
}
</style>
